const REF_REG = new RegExp(/^(P?Q\d+)(?:SQ(\d+))?$/, 'i')

export const getItems = (refs = [], questions = {}) => {
  let maxAnswerPosition = 0
  let type = null
  let subtype = null
  let items = []

  for (const ref of refs) {
    if ('NULL' === ref) continue

    if (!ref.trim().length) {
      items = []
      break
    }

    const m = ref.trim().match(REF_REG)
    if (null === m) {
      items = []
      break
    }

    const q = questions[m[1].toUpperCase()]
    if (q == undefined) {
      items = []
      break
    }

    type ||= q.variant || q.type
    subtype = q.subtype
    if (type != (q.variant || q.type)) {
      type = null
      subtype = null
      items = []
      break
    }

    maxAnswerPosition = q.maxAnswerPosition

    if (m[2] != undefined) {
      const b = q.batches != undefined && q.batches[Number(m[2]) - 1]
      if (b != undefined && b.answerVariants != undefined) items.push(b)
    } else if (q.answerVariants != undefined) items.push(q)
  }

  return { type, subtype, items, maxAnswerPosition }
}

const getMultiMethodsOptions = (items, maxAnswerPosition) => {
  const methods = []

  if (!items.slice(1).some((item, i) => item.answerVariants.length != items[i].answerVariants.length)) {
    let answerVariants = items[0].answerVariants.filter(av => !Object.hasOwn(av, 'positive') || av.positive)
    if (2 > answerVariants.length) return methods

    const reversed = 1 < maxAnswerPosition
    reversed && (answerVariants = [...answerVariants].reverse())

    for (const answerVariant of answerVariants) {
      const key = `a${answerVariant.position}`
      methods.push({
        key,
        text: `<b>${answerVariant.text}</b><br/>${key.toUpperCase()}`,
        label: key.toUpperCase()
      })
    }

    const naAnswerVariants = items[0].answerVariants.filter(av => Object.hasOwn(av, 'positive') && !av.positive)
    if (0 < naAnswerVariants.length) {
      for (const naAnswerVariant of naAnswerVariants) {
        const key = `a${naAnswerVariant.position}`
        methods.push({
          key,
          text: `<b>${naAnswerVariant.text}</b><br/>${key.toUpperCase()}`,
          label: key.toUpperCase()
        })
      }
    }
  }

  return methods
}

const getSingleMethodOptions = (type, items, maxAnswerPosition) => {
  const methods = []

  if (!items.slice(1).some((item, i) => item.answerVariants.length != items[i].answerVariants.length)) {
    let answerVariants = items[0].answerVariants.filter(av => !Object.hasOwn(av, 'positive') || av.positive)
    if (2 > answerVariants.length) return methods

    const reversed = ['sr', 'se'].includes(type) || 1 < maxAnswerPosition
    reversed && (answerVariants = [...answerVariants].reverse())

    methods.push({
      key: (reversed && 'bottom1') || 'top1',
      text: `A${answerVariants[0].position}: <b>${answerVariants[0].text}</b>`,
      label: `A${answerVariants[0].position}`
    })

    if (2 < answerVariants.length) {
      for (const answerVariant of answerVariants.slice(1, -1)) {
        const key = `a${answerVariant.position}`
        methods.push({
          key,
          text: `${key.toUpperCase()}: <b>${answerVariant.text}</b>`,
          label: key.toUpperCase()
        })
      }
    }

    methods.push({
      key: (reversed && 'top1') || 'bottom1',
      text: `A${answerVariants[answerVariants.length - 1].position}: <b>${
        answerVariants[answerVariants.length - 1].text
      }</b>`,
      label: `A${answerVariants[answerVariants.length - 1].position}`
    })

    const naAnswerVariants = items[0].answerVariants.filter(av => Object.hasOwn(av, 'positive') && !av.positive)
    if (0 < naAnswerVariants.length) {
      for (const naAnswerVariant of naAnswerVariants) {
        const key = `a${naAnswerVariant.position}`
        methods.push({
          key,
          text: `${key.toUpperCase()}: <b>${naAnswerVariant.text}</b>`,
          label: key.toUpperCase()
        })
      }
    }

    if (2 < answerVariants.length)
      methods.push({
        key: (reversed && 'bottom2') || 'top2',
        text: `<b>Top 2 Box</b> (A${answerVariants[0].position}: ${answerVariants[0].text}, A${answerVariants[1].position}: ${answerVariants[1].text})`,
        label: `Top 2 Box: A${answerVariants[0].position}-${answerVariants[1].position}`
      })
    if (3 < answerVariants.length)
      methods.push({
        key: (reversed && 'bottom3') || 'top3',
        text: `<b>Top 3 Box</b> (A${answerVariants[0].position}: ${answerVariants[0].text}, A${answerVariants[1].position}: ${answerVariants[1].text}, A${answerVariants[2].position}: ${answerVariants[2].text})`,
        label: `Top 3 Box: A${answerVariants[0].position}-${answerVariants[2].position}`
      })
    if (2 < answerVariants.length)
      methods.push({
        key: (reversed && 'bottom2w') || 'top2w',
        text: `<b>T-Weighted</b> (100% A${answerVariants[0].position}: ${answerVariants[0].text}, 50% A${answerVariants[1].position}: ${answerVariants[1].text})`,
        label: `T-Weighted: 100% A${answerVariants[0].position} + 50% A${answerVariants[1].position}`
      })

    if (2 < answerVariants.length)
      methods.push({
        key: (reversed && 'top2') || 'bottom2',
        text: `<b>Top 2 Box</b> (A${answerVariants[answerVariants.length - 2].position}: ${
          answerVariants[answerVariants.length - 2].text
        }, A${answerVariants[answerVariants.length - 1].position}: ${answerVariants[answerVariants.length - 1].text})`,
        label: `Top 2 Box: A${answerVariants[answerVariants.length - 2].position}-${
          answerVariants[answerVariants.length - 1].position
        }`
      })
    if (3 < answerVariants.length)
      methods.push({
        key: (reversed && 'top3') || 'bottom3',
        text: `<b>Top 3 Box</b> (A${answerVariants[answerVariants.length - 3].position}: ${
          answerVariants[answerVariants.length - 3].text
        }, A${answerVariants[answerVariants.length - 2].position}: ${
          answerVariants[answerVariants.length - 2].text
        }, A${answerVariants[answerVariants.length - 1].position}: ${answerVariants[answerVariants.length - 1].text})`,
        label: `Top 3 Box: A${answerVariants[answerVariants.length - 3].position}-${
          answerVariants[answerVariants.length - 1].position
        }`
      })
    if (2 < answerVariants.length)
      methods.push({
        key: (reversed && 'top2w') || 'bottom2w',
        text: `<b>T-Weighted</b> (50% A${answerVariants[answerVariants.length - 2].position}: ${
          answerVariants[answerVariants.length - 2].text
        }, 100% A${answerVariants[answerVariants.length - 1].position}: ${
          answerVariants[answerVariants.length - 1].text
        })`,
        label: `T-Weighted: 50% A${answerVariants[answerVariants.length - 2].position} + 100% ${
          answerVariants[answerVariants.length - 1].position
        }`
      })

    methods.push({
      key: 'means',
      text: '<b>Mean</b>',
      label: 'Mean'
    })
    methods.push({
      key: 'meansReversed',
      text: '<b>Mean</b> (reverse coded)',
      label: 'Mean (reverse coded)'
    })
  }

  return methods
}

export const getMethodOptions = (refs = [], questions = {}) => {
  const { type, subtype, items, maxAnswerPosition } = getItems(refs, questions)

  const methods =
    0 < items.length
      ? ['rb', 'mx', 'sr', 'se'].includes(type) || ('mp' == type && 'radios' == subtype)
        ? getSingleMethodOptions(type, items, maxAnswerPosition)
        : getMultiMethodsOptions(items, maxAnswerPosition)
      : []

  return { type, subtype, methods }
}
